export default __webpack_public_path__ + "static/media/track_report_bg.cded1845.svg";